import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';
import { WithUnderline } from '../WithUnderline';
export const AnswerInput = forwardRef<HTMLInputElement, ComponentPropsWithoutRef<'input'>>(({
  className,
  placeholder,
  value,
  onChange,
  ...rest
}, ref) => {
  return <div className="group w-full">
      <WithUnderline>
        <input {...rest} type="text" value={value} ref={ref} onChange={onChange} placeholder={placeholder} maxLength={50} className={cn('w-full truncate border-none bg-transparent text-heading-sm-bold outline-none placeholder:text-content-alternative', className)} />
      </WithUnderline>
    </div>;
});